import toastr from 'react-hot-toast'
import { useMutation, useQueryClient } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import type {
  ApplicationUserAttribute,
  SingleApplicationUserResponse,
} from 'types/ApplicationUser'
import { generateURL } from 'utilities/hooks/urlGeneration'
import { SPARK_RESOURCE_TYPES } from 'constants/common'

type mutationApplicationUserVariables = Partial<ApplicationUserAttribute>

export function useUpdateApplicationUser(userID: string | null | undefined) {
  const queryClient = useQueryClient()

  const UpdateApplicationUser = (
    variables: mutationApplicationUserVariables
  ) => {
    if (!userID) {
      Promise.reject('User ID not found')
    }

    const body = {
      data: {
        id: userID,
        type: SPARK_RESOURCE_TYPES.APPLICATION_USERS,
        attributes: variables,
      },
    }
    const url = generateURL(SPARK_RESOURCE_TYPES.APPLICATION_USERS)
    return fetchWrapper<SingleApplicationUserResponse>({
      url: `${url}/${userID}`,
      method: 'PATCH',
      body: body,
    })
  }

  return useMutation('UpdateApplicationUser', UpdateApplicationUser, {
    onSuccess: () => {
      // Invalidate the query for the updated user
      queryClient.invalidateQueries(['ApplicationUser', userID])
      toastr.success('User updated successfully')
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to update user: ${error.message}`)
      }
    },
  })
}
